export const appVersionLabel = process.env.REACT_APP_VERSION;
export const appBuild = process.env.REACT_APP_BUILD || 'dev';